import { useEffect, useState } from 'react';

import type { LensFilterValues } from '~/types/leLens';

import { useGetReportingLeLensData } from './useGetReportingLeLensData';

const CHOICE_DEBOUNCE_MS = 300;

/** An opt-in choices-only request; report requests and other native pages keep their timing. */
export function useGetNativeChoices(lensId: string | undefined, filters: LensFilterValues, cardId = 'choices') {
  const identity = JSON.stringify([lensId, filters, cardId]);
  const [settled, setSettled] = useState({ identity, lensId, filters, cardId });
  useEffect(() => {
    const timer = setTimeout(() => {
      const [nextLensId, nextFilters, nextCardId] = JSON.parse(identity);
      setSettled({ identity, lensId: nextLensId, filters: nextFilters, cardId: nextCardId });
    }, CHOICE_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [identity]);
  const query = useGetReportingLeLensData(settled.lensId, settled.filters, false, undefined, undefined, undefined, [
    settled.cardId,
  ]);
  return {
    ...query,
    current:
      identity === settled.identity &&
      query.isSuccess &&
      !query.isFetching &&
      !query.isShowingPreviousData &&
      query.responseIdentity === query.requestIdentity,
  };
}
